import m from "mithril";
import { MithrilTsxComponent } from "mithril-tsx-component";
import { DEFAULT_IMAGE, getProductName } from "../../state/api";
import { getCrosssell } from "../../state/data";
import state from "../../state/state";
import { getText, getTextFixed } from "../../state/translations";
import { cleanString } from "oj-utils";
import { formatCurrency, getAsset } from "../../utils/utils";
import { QuantitySelector } from "../quantity-selector/quantity-selector";
import { sharedProductUtils } from "../productDetail/productDetail";
import "./relatedProducts.scss";
import { onderlegSet } from "../../state/data/onderleg_platen";
import { dialog } from "../dialog/dialog";
import { Checkbox } from "../checkbox/checkbox";
import { Button } from "../button/button";
import { Svg } from "../svg/svg";
import { isLoggedIn } from "../../utils/login";
export class RelatedProducts extends MithrilTsxComponent {
    relatedItems = [];
    subs = [];
    oninit(v) {
        this.buildRelated(v);
        this.subs.push(state.on("quantity:change", () => {
            this.buildRelated(v);
        }));
    }
    buildRelated(v) {
        const variantProduct = Object.values(state.products.variants).find(vr => vr?.artCodeTSNL === v.attrs.article.artCodeTSNL);
        const crossell = getCrosssell(variantProduct ?? v.attrs.article.item, () => {
            m.redraw();
        });
        this.relatedItems = crossell.map(item => ({
            item,
            category: getText(item.category, undefined, item.category),
            qty: state.getCrosssellQuantity(v.attrs.article.artCodeTSNL, item.artCodeTSNL)
        }));
    }
    view(v) {
        if (!this.relatedItems.length)
            return;
        return m("div", { className: "RelatedProducts" },
            m("div", { className: "title" },
                m("span", null, getTextFixed("RELATED_PARTS"))),
            m("div", { className: "related-products" }, this.relatedItems.map(item => {
                const name = getProductName(item.item);
                const quantity = state.getCrosssellQuantity(v.attrs.article.artCodeTSNL, item.item.artCodeTSNL);
                const itemPrice = (item.item.price ?? 0); // * (quantity ?? 1)
                return m("div", { className: "related-product" },
                    m("button", { className: "details", type: "button", onclick: async (e) => {
                            const full = await item.item.promise;
                            sharedProductUtils.openDialog(e, full, undefined, v.attrs.article.artCodeTSNL);
                            m.redraw();
                        } },
                        m("div", { className: "image" },
                            m("img", { src: item.item.thumbnail ?? DEFAULT_IMAGE, alt: name, className: cleanString(!item.item.thumbnail && "is-fallback-image") })),
                        m("span", { className: "name" }, name)),
                    m("div", { className: "actions" },
                        m("span", { className: "price" }, (isLoggedIn && itemPrice) ? formatCurrency(itemPrice) : "€-,--"),
                        m(QuantitySelector, { min: 0, value: quantity, onchange: value => {
                                const sub = state.on("quantity:change", async (x) => {
                                    if (x.rejected && onderlegSet.has(x.artCodeTSNL)) {
                                        let acknowledged = false;
                                        const r = await dialog({
                                            className: "confirm-dialog onderlegset-warning-dialog",
                                            title: getTextFixed("ONDERLEGSET_WARNING_TITLE"),
                                            dismiss: false,
                                            close: false,
                                        }, c => [
                                            m("p", null, getTextFixed("ONDERLEGSET_WARNING_BODY_1")),
                                            m("p", null, getTextFixed("ONDERLEGSET_WARNING_BODY_2")),
                                            m("hr", { className: "warning-divider" }),
                                            m("label", { className: "warning-checkbox-label" },
                                                m(Checkbox, { checked: acknowledged, onchange: () => { acknowledged = !acknowledged; m.redraw(); } }),
                                                m("span", null, getTextFixed("ONDERLEGSET_WARNING_CHECKBOX"))),
                                            m("div", { className: "dialog-footer" },
                                                m(Button, { text: getTextFixed("YES_DELETE"), className: "button-default", disabled: !acknowledged, onclick: () => acknowledged && c("remove") }),
                                                m(Button, { text: getTextFixed("KEEP_PRODUCT"), className: "button-secondary", onclick: () => c() }))
                                        ]).promise;
                                        if (r === "remove")
                                            state.setCrosssellQuantity(v.attrs.article.artCodeTSNL, x.artCodeTSNL, value, undefined, true);
                                    }
                                });
                                state.setCrosssellQuantity(v.attrs.article.artCodeTSNL, item.item.artCodeTSNL, value);
                                sub.off();
                            } })),
                    onderlegSet.has(item.item.artCodeTSNL) &&
                        m("div", { className: "onderleg-note" },
                            m(Svg, { className: "icon", src: getAsset("icons/info3.svg") }),
                            m("span", { className: "onderleg-note" }, getTextFixed("ONDERLEG_NOTE"))));
            })));
    }
}
